// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TKIo","toggle":"styles_toggle__3lyzy","preview":"styles_preview__3dgLU"};